import { Outlet } from "react-router-dom";

const InvoicesParentPage = () => {
    return <Outlet />
}
export default InvoicesParentPage;